import { render, staticRenderFns } from "./promotionNUDG.vue?vue&type=template&id=4959c873&scoped=true"
import script from "./promotionNUDG.vue?vue&type=script&lang=js"
export * from "./promotionNUDG.vue?vue&type=script&lang=js"
import style0 from "./promotionNUDG.vue?vue&type=style&index=0&id=4959c873&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4959c873",
  null
  
)

export default component.exports